import { cn } from '@/lib/utils';
import { choiceColor, choiceLetter } from './constants';

export function LetterTile({
  index,
  className,
  size = 30,
}: {
  index: number;
  className?: string;
  size?: number;
}) {
  return (
    <span
      className={cn(
        'grid shrink-0 place-items-center font-screen-heading font-normal text-black',
        className,
      )}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(6, size * 0.22),
        background: choiceColor(index),
        fontSize: size * 0.5,
      }}
    >
      {choiceLetter(index)}
    </span>
  );
}
